//initial redux
import { put, call, takeEvery, fork, all, take, select } from "redux-saga/effects";
import * as router from "react-router-redux";
import { eventChannel, delay } from "redux-saga";
import reportsservice from "../../../../services/reports";
import moment from "moment";
import pointsservice from "../../../../services/points";

const initialState = {
	instances: {}
};

const heatMapTiers = 7;

/////////
//types
export const types = {
	INIT_COMPONENT: "components/hourlyfailureheatmap/INIT_COMPONENT",
	LOAD_DATA: "components/hourlyfailureheatmap/LOAD_DATA",
	SET_COMPONENT_DATA: "components/hourlyfailureheatmap/SET_COMPONENT_DATA"
};

function getHeatMapColor(tier, failCount, passCount) {
	if (failCount === 0 && passCount === 0) {
		// rule didnt run return grey
		return "#ccc";
	}
	switch (tier) {
		case 1:
			return "#63BE7B";
		case 2:
			return "#93CC7D";
		case 3:
			return "#AFD47F";
		case 4:
			return "#CCDC81";
		case 5:
			return "#FBE983";
		case 6:
			return "#FCAC78";
		case 7:
			return "#F8696B";
		default:
			return "#FFFFFF";
	}
}

function initComponent(state, action) {
	const id = action.payload.id;
	const component = action.payload.component;
	//do nothing if it's already init
	if (state.instances.id) {
		return state;
	}
	let componentData = {};
	return { ...state, instances: { ...state.instances, [id]: componentData } };
}

function setComponentData(state, action) {
	const id = action.payload.id;
	const componentData = action.payload.componentData;
	return { ...state, instances: { ...state.instances, [id]: componentData } };
}

///////////
//reducers
export const reducers = {
	reducer(state = initialState, action) {
		switch (action.type) {
			case types.INIT_COMPONENT: {
				return initComponent(state, action);
			}
			case types.LOAD_DATA: {
				return state;
			}
			case types.SET_COMPONENT_DATA: {
				return setComponentData(state, action);
			}
			default:
				return state;
		}
	}
};

//////////
//sagas
export const sagas = {
	*rootSaga() {
		yield all([this.loadData()]);
	},

	*loadData() {
		yield takeEvery(types.LOAD_DATA, function*({ payload }) {
			const component = payload.component;
			const id = payload.id;
			const fromDate = moment(payload.timePeriod.startDate);
			const toDate = moment(payload.timePeriod.endDate);
			const componentData = {
				hourlyFailures: []
			};
			const hourlyFailures = yield call(
				reportsservice.GetHourlyFailures,
				component.ruleInstanceId,
				fromDate,
				toDate
			);

			let min = Number.MAX_SAFE_INTEGER;
			let max = 0;

			hourlyFailures.forEach(hourlyFailure => {
				if (hourlyFailure.failCount < min) {
					min = hourlyFailure.failCount;
				}
				if (hourlyFailure.failCount > max) {
					max = hourlyFailure.failCount;
				}
			});

			let spread = max - min;
			//divide by the number of tiers EXCEPT in the case where the spread doesnt cover the number of tiers in which case divide by the spread.
			//This is for teh scenarios when the failures are all (almost) even then it will reduce the color range by reducing the tiers to the spread.
			let spreadPerTier = spread === 0 ? 1 : spread / (spread < heatMapTiers ? spread : heatMapTiers);

			hourlyFailures.forEach(hourlyFailure => {
				let heatMapTier = Math.floor((hourlyFailure.failCount - min) / spreadPerTier) + 1;
				//If spread is higher than nuber of tiers Then the hour with max failures will end up with a tier 1 higher than what is available due to rounding.
				//in this case bring the tier back to max
				heatMapTier = heatMapTier > heatMapTiers ? heatMapTiers : heatMapTier;
				let display = hourlyFailure.hour;
				if (display === 0) {
					display = 12;
				} else if (display > 12) {
					display = display % 12;
				}
				display += hourlyFailure.hour < 12 ? "am" : "pm";
				componentData.hourlyFailures.push({
					color: getHeatMapColor(heatMapTier, hourlyFailure.failCount, hourlyFailure.passCount),
					hour: hourlyFailure.hour,
					display: display,
					count: hourlyFailure.failCount
				});
			});

			yield put(actions.setComponentData(id, componentData));
			if (payload.onLoadComplete) {
				payload.onLoadComplete();
			}
		});
	}
};

////////
//actions
export const actions = {
	initComponent(id, component) {
		return {
			type: types.INIT_COMPONENT,
			payload: { id, component }
		};
	},
	loadData(id, component, timePeriod, onLoadComplete) {
		return {
			type: types.LOAD_DATA,
			payload: { id, component, timePeriod, onLoadComplete }
		};
	},
	setComponentData(id, componentData) {
		return {
			type: types.SET_COMPONENT_DATA,
			payload: { id, componentData }
		};
	}
};



// WEBPACK FOOTER //
// ./src/components/ReportComponents/HeatMaps/HourlyFailureHeatMap/redux.js